var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"appContent"},[_c('div',{ref:"fullScreenBox",staticStyle:{"height":"100%","width":"100%"}},[_c('PageView',{attrs:{"include":_vm.include,"max":100}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }